// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2hh6g","unreadBadge":"styles_unreadBadge__3gA5r","modalContent":"styles_modalContent__SjjM-","modal":"styles_modal__2yeo8"};